var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('config-item',{attrs:{"label":_vm.label}},[_c('div',{staticClass:"flex row-right schema-image"},[_c('Imgpond',{attrs:{"count":1},model:{value:(_vm.mValue),callback:function ($$v) {_vm.mValue=$$v},expression:"mValue"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }